import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { format } from 'date-fns';
import { Alert, Button, Loader, Modal, Table } from '@itds/elements';
import { RIDER_LABELS } from '@itds/Constants';

import EditTableRateDrawer from './Edit';

import Api from '@carrier/utils/Api';

function getAvailableStates(row) {
  if (!row || typeof row !== 'object') {
    return '';
  }

  const states = Object
    .entries(row)
    .filter(([key, value]) => {
      return key.startsWith('state_') && value === true;
    })
    .map(([key]) => {
      return key.replace('state_', '').toUpperCase();
    });

  return states.join(', ');
}

const List = () => {
  const params = useParams();

  const [riders, setRiders] = useState([]);
  const [rider, setRider] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error_message, setErrorMessage] = useState(null);
  const [success_message, setSuccessMessage] = useState(null);
  const [modal, setModal] = useState(false);
  const [deleteInfo, setDeleteInfo] = useState(null);

  useEffect(() => {
    loadRiders();
  }, []);

  const loadRiders = action => {
    setLoading(true);

    setTimeout(() => {
      setSuccessMessage(null);
      setErrorMessage(null);
    }, 2000);

    Api.loadRiders({ carrier_id: params.id, data_version_id: params.version_id })
      .then(({ data }) => {
        setLoading(false);
        setRiders(data);

        if (action === 'add') {
          setSuccessMessage('Riders Successfully Added');
        } else if (action === 'delete') {
          setSuccessMessage('Rider Successfully Deleted');
        }
      })
      .catch(() => {
        if (action === 'add') {
          setErrorMessage('Unable to add Riders at this time');
        } else if (action === 'delete') {
          setErrorMessage('Unable to delete Riders at this time');
        }
      });
  };

  const handleSave = () => {
    setRider(null);
    loadRiders('add');
  };

  if (loading) {
    return <Loader />;
  }

  return (
    <>
      {success_message ? <Alert type='success'>{success_message}</Alert> : null}
      {error_message ? <Alert type='error'>{error_message}</Alert> : null}

      <EditTableRateDrawer
        onClose={setRider.bind(null, null)}
        onSave={handleSave}
        rider={rider}
        show={!!rider}
      />

      <div style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: 30 }}>
        <Button
          onClick={setRider.bind(null, {
            carrier_id: params.id,
            data_version_id: params.version_id
          })}
        >
          Add Rider
        </Button>
      </div>

      <Table
        columns={[
          {
            id: 'name',
            label: 'Name',
          },
          {
            id: 'id',
            label: 'ID',
            styles: { minWidth: '80px' }
          },
          {
            id: 'rider_type',
            is_sortable: true,
            label: 'Type',
            render: row => {
              return RIDER_LABELS[row.rider_type];
            }
          },
          {
            id: 'data_version_id',
            label: 'Version'
          },
          {
            id: 'states_available',
            label: 'States Available',
            render: row => {
              return getAvailableStates(row);
            }
          },
          {
            id: 'updated_at',
            label: 'Last Updated',
            render: row => {
              return format(new Date(row.updated_at), 'MM/dd/yyyy');
            }
          }
        ]}
        data={riders}
        defaultSortColumn={{ id: 'rider_type' }}
        onRowClick={setRider}
      />
    </>
  );
};

export default List;
